import { render, staticRenderFns } from "./user_distribution.vue?vue&type=template&id=98b9c862"
import script from "./user_distribution.vue?vue&type=script&lang=js"
export * from "./user_distribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports